function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import EventEmitter from './events';
export var isString = function isString(unknown) {
  return typeof unknown === 'string' || !!unknown && _typeof(unknown) === 'object' && Object.prototype.toString.call(unknown) === '[object String]';
};

var bulmaSlider = /*#__PURE__*/function (_EventEmitter) {
  _inherits(bulmaSlider, _EventEmitter);

  var _super = _createSuper(bulmaSlider);

  function bulmaSlider(selector) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, bulmaSlider);

    _this = _super.call(this);
    _this.element = typeof selector === 'string' ? document.querySelector(selector) : selector; // An invalid selector or non-DOM node has been provided.

    if (!_this.element) {
      throw new Error('An invalid selector or non-DOM node has been provided.');
    }

    _this._clickEvents = ['click']; /// Set default options and merge with instance defined

    _this.options = _objectSpread({}, options);
    _this.onSliderInput = _this.onSliderInput.bind(_assertThisInitialized(_this));

    _this.init();

    return _this;
  }
  /**
   * Initiate all DOM element containing selector
   * @method
   * @return {Array} Array of all slider instances
   */


  _createClass(bulmaSlider, [{
    key: "init",
    value:
    /**
     * Initiate plugin
     * @method init
     * @return {void}
     */
    function init() {
      this._id = 'bulmaSlider' + new Date().getTime() + Math.floor(Math.random() * Math.floor(9999));
      this.output = this._findOutputForSlider();

      this._bindEvents();

      if (this.output) {
        if (this.element.classList.contains('has-output-tooltip')) {
          // Get new output position
          var newPosition = this._getSliderOutputPosition(); // Set output position


          this.output.style['left'] = newPosition.position;
        }
      }

      this.emit('bulmaslider:ready', this.element.value);
    }
  }, {
    key: "_findOutputForSlider",
    value: function _findOutputForSlider() {
      var _this2 = this;

      var result = null;
      var outputs = document.getElementsByTagName('output') || [];
      Array.from(outputs).forEach(function (output) {
        if (output.htmlFor == _this2.element.getAttribute('id')) {
          result = output;
          return true;
        }
      });
      return result;
    }
  }, {
    key: "_getSliderOutputPosition",
    value: function _getSliderOutputPosition() {
      // Update output position
      var newPlace, minValue;
      var style = window.getComputedStyle(this.element, null); // Measure width of range input

      var sliderWidth = parseInt(style.getPropertyValue('width'), 10); // Figure out placement percentage between left and right of input

      if (!this.element.getAttribute('min')) {
        minValue = 0;
      } else {
        minValue = this.element.getAttribute('min');
      }

      var newPoint = (this.element.value - minValue) / (this.element.getAttribute('max') - minValue); // Prevent bubble from going beyond left or right (unsupported browsers)

      if (newPoint < 0) {
        newPlace = 0;
      } else if (newPoint > 1) {
        newPlace = sliderWidth;
      } else {
        newPlace = sliderWidth * newPoint;
      }

      return {
        'position': newPlace + 'px'
      };
    }
    /**
     * Bind all events
     * @method _bindEvents
     * @return {void}
     */

  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      if (this.output) {
        // Add event listener to update output when slider value change
        this.element.addEventListener('input', this.onSliderInput, false);
      }
    }
  }, {
    key: "onSliderInput",
    value: function onSliderInput(e) {
      e.preventDefault();

      if (this.element.classList.contains('has-output-tooltip')) {
        // Get new output position
        var newPosition = this._getSliderOutputPosition(); // Set output position


        this.output.style['left'] = newPosition.position;
      } // Check for prefix and postfix


      var prefix = this.output.hasAttribute('data-prefix') ? this.output.getAttribute('data-prefix') : '';
      var postfix = this.output.hasAttribute('data-postfix') ? this.output.getAttribute('data-postfix') : ''; // Update output with slider value

      this.output.value = prefix + this.element.value + postfix;
      this.emit('bulmaslider:ready', this.element.value);
    }
  }], [{
    key: "attach",
    value: function attach() {
      var _this3 = this;

      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'input[type="range"].slider';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var instances = new Array();
      var elements = isString(selector) ? document.querySelectorAll(selector) : Array.isArray(selector) ? selector : [selector];
      elements.forEach(function (element) {
        if (typeof element[_this3.constructor.name] === 'undefined') {
          var instance = new bulmaSlider(element, options);
          element[_this3.constructor.name] = instance;
          instances.push(instance);
        } else {
          instances.push(element[_this3.constructor.name]);
        }
      });
      return instances;
    }
  }]);

  return bulmaSlider;
}(EventEmitter);

export { bulmaSlider as default };